module.exports = "<input type=\"text\" class=\"form-control\" value=\"<% if (value) print(value); %>\"<% if (name) print(\" name=\"+name); %>>"